import React from 'react';
import { useSpring } from 'react-spring';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import Tooltip from '../../components/action/TooltipWrapper';
import ChainTableContainer from '../../components/TableContainer/ChainTableContainer';
import ThemedText from '../../components/theme/ThemedText';
import ThemeLogo from '../../components/theme/ThemeLogo';
import UserReputation from '../../components/UserReputation/UserReputation';
import { useMrepState } from '../../helpers/mrepHelper';

const ChainReputation = () => {
  const springProps = useSpring({
    from: { transform: 'translateY(-25px)', opacity: 0 },
    to: { transform: 'translateY(0)', opacity: 1 },
    config: { tension: 200, friction: 20 },
  });

  const [{ chainRanking }] = useMrepState();
  const [{ chainFilter, setValue, chainActionStats, chainRankingLoading }] = useMrepState();
  function updateAction(value) {
    setValue('chainFilter', { ...(chainFilter || {}), action: value });
  }

  return (
    <FlexboxColumn fw style={springProps}>
      <Flexbox fw justifyContent='space-between'>
        <Flexbox gap='0.5rem'>
          <ThemedText.H4 weight={'semi-bold'}>Chain Stats </ThemedText.H4>
          <Tooltip
            position={'right'}
            content={
              "Chain Stats measures your engagement across various blockchain networks by analyzing your contributions across different dApps on each chain. We aggregate your swaps, deposits, and bridge transactions, then compare them with other users to determine your ranking. This ranking reflects your overall activity and influence within each chain's ecosystem."
            }
          >
            <ThemeLogo icon={'info'} />
          </Tooltip>
        </Flexbox>
        <Flexbox>{/* <SearchBar /> */}</Flexbox>
      </Flexbox>

      <UserReputation data={chainActionStats} filter={chainFilter?.action} onChange={updateAction} />
      <ChainTableContainer data={chainRanking} isLoading={chainRankingLoading} />
    </FlexboxColumn>
  );
};

export default ChainReputation;
